import { useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import { SearchSelect } from '@fortem-monorepo/react-ui'

import { useInvestmentBucketsQuery } from '@/react-query/queries/static'

export interface InvestmentBucketIdCellEditorProps extends CustomCellEditorProps {}

export const InvestmentBucketIdCellEditor: React.FC<InvestmentBucketIdCellEditorProps> = ({
  value,
  onValueChange,
  stopEditing,
}) => {
  const [open, setOpen] = useState(true)

  const query = useInvestmentBucketsQuery()

  return (
    <div className={'flex items-center h-full!'}>
      <SearchSelect
        className={'text-xs ag-custom-component-popup w-full min-w-auto! border-0!'}
        open={open}
        setOpen={setOpen}
        setValue={(val) => {
          onValueChange(val !== null ? parseInt(val) : null)
          stopEditing()
        }}
        value={value?.toString()}
        options={query.data?.map((c) => ({
          label: c.label,
          value: c.value?.toString(),
        }))}
      />
    </div>
  )
}
